/* eslint-disable camelcase */
// eslint-disable-next-line import/no-unresolved
import 'awesomplete/awesomplete.min';
import './product-search.scss';
import { mapGetters, mapActions } from 'vuex';
import { FuzzySearch } from '@garmin/support-fuzzy-search';
import { FormatUrlParameters } from '@garmin/support-utils';
import { marked } from 'marked';
import * as ComponentConfig from './config';
import Utils from '../../lib/utils';
import { trackEventFor, trackEventMapFor } from '../../app/store/util';

export default {
  name: 'ProductSearch',

  props: {
    children: {
      default() {
        return [];
      },
      type: Array,
    },
    customProps: {
      default() {
        return {};
      },
      type: Object,
    },
    displayProductSearch: {
      type: Boolean,
      default: true,
    },
    faqSideDoorEnabled: {
      type: Boolean,
      default: false,
    },
  },
  async beforeCreate() {
    if (this.$store.getters.productList.length === 0) {
      const currentUrl = window.location.href;
      const versionRegex = /version=(v)*[0-9]+/gi;
      const matchedVersionString = versionRegex.exec(currentUrl);
      let version = false;

      if (matchedVersionString !== null) {
        version = matchedVersionString[0].split('=').pop();
      }

      await this.$store.dispatch('fetchProductListByLocale', version);
    }
  },
  mounted() {
    this.autocompleteSetup();
    this.$refs.autocompleteInput.addEventListener('awesomplete-highlight', this.onAutoCompleteTabSelect);
    this.$refs.autocompleteInput.addEventListener('awesomplete-selectcomplete', this.confirmAutocomplete);
    this.$refs.autocompleteInput.addEventListener('awesomplete-selectcomplete', this.handleSubmit);
    if (this.faqSideDoorEnabled) trackEventMapFor(this.$store.getters.faqDetails.publishedId, 'Product Selector - Presented');

    this.updateProductSearchErrors({ mutation: 'errorSearchTerm', value: null });
    this.resetErrors();
  },
  data() {
    return {
      baseUrl: window.location.origin,
      internalSearchTerm: '',
      isToolTipClicked: false,
      confirmedProductIdentifiers: false,
      productId: false,
      partNumber: false,
      zeroResultsFlag: false,
      tooManyResultsFlag: false,
      customErrorFlag: false,
      translations: {
        productFlowAriaLabel: this.$safeGet(
          this.$store.getters.translations,
          'references.scHomeProductFlow.ariaLabel',
          '',
        ),
        productFlowInput: this.$safeGet(
          this.$store.getters.translations,
          'references.scHomeProductFlow.instructions',
          '',
        ),
        productFlowPlaceholder: this.$safeGet(
          this.$store.getters.translations,
          'references.scHomeProductFlow.placeholder',
          '',
        ),
        productFlowButtonTitle: this.$safeGet(
          this.$store.getters.translations,
          'references.scHomeProductFlow.buttonTitle',
          '',
        ),
        productFlowGenericError: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productError',
          '',
        ),
        productFlowSpecificityErrorDesc: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productSpecificityDescription',
          '',
        ),
        productFlowSpecificityErrorLink: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productSpecificityUrl.urlProductSpecificityError.link',
          '',
        ),
        productFlowSpecificityErrorActionText: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productSpecificityUrl.urlProductSpecificityError.text',
          '',
        ),
        productFlowZeroResultsErrorDesc: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productZeroResultsDescription',
          '',
        ),
        productFlowZeroResultsErrorLink: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productZeroResultsUrl.urlProductZeroResultsError.link',
          '',
        ),
        productFlowZeroResultsErrorActionText: this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productZeroResultsUrl.urlProductZeroResultsError.text',
          '',
        ),
        productSearchContentIncorrect: decodeURIComponent(marked(this.$safeGet(
          this.$store.getters.translations,
          'references.scProductEntryErrors.productSearchContentIncorrect',
          '',
        ))),
        productSearchTransitionInformationLabel: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.productSearchMessageLabel',
          '',
        ),
        productSearchTransitionInformationText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.productSearchMessageText',
          '',
        ),
        productSearchTransitionInformationFaqLink: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.productSearchMessageUrl.urlTransitionMessageLink.link',
          '',
        ),
        productSearchTransitionInformationFaqLinkText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.productSearchMessageUrl.urlTransitionMessageLink.text',
          '',
        ),
        noProductFlowLink: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.noProductFlowUrl.urlNoProductFlow.link',
          '',
        ),
        changeSearchType: this.$safeGet(
          this.$store.getters.translations,
          'references.scAlternateFlows.noProductFlowEntry',
          '',
        ),
      },

    };
  },
  computed: {
    ...mapGetters([
      'productListAutocomplete',
      'isProductFaqRelatedContent',
      'product',
      'productDetailsFaqSearch',
      'urlParams',
      'faqSideDoorSearchError',
      'error',
      'errorMessage',
      'errorOverrideMessage',
      'genericError',
      'specificityErrorMessage',
      'zeroResultsErrorMessage',
      'errorSearchTerm',
    ]),
    getFaqSideDoorSearchError() {
      const partNumber = this.productDetailsFaqSearch?.partNumber;
      const productId = this.productDetailsFaqSearch?.productId;
      return this.translations.productSearchContentIncorrect.replace(
        '<a href="{productUrl}">',
        `<a href="${window.location.origin}/${window.AppData.locale}/?identifier=${(partNumber || productId)}&tab=topics"
          id="faq-identified-missmatch-link"
        >`,
      );
    },
    getProductDisplayName() {
      if (this.product) return this.product.displayName;
      if (this.isProductFaqRelatedContent(this.productDetailsFaqSearch?.faqTags)) return this.productDetailsFaqSearch.displayName;
      return '';
    },
  },
  methods: {
    ...mapActions([
      'fetchProductDetails',
      'updateFaqSideDoorSearchError',
      'resetSearchErrors',
      'updateProductSearchErrors',
    ]),
    onHelpLinkClick(payload) {
      const {
        event_label, link,
      } = payload;

      if (this.zeroResultsFlag && event_label === 'Zero Result') trackEventMapFor('Help Link', 'Product Selector - No Match - Zero Results - Link');
      if (this.tooManyResultsFlag && event_label === 'Specificity') trackEventMapFor('Help Link', 'Product Selector - No Match - Specificity - Link');
      if (this.customErrorFlag && event_label === `Custom Error - ${this.errorSearchTerm}`) trackEventMapFor('Help Link', 'Product Selector - No Match - Custom Error - Link'); //eslint-disable-line

      if (link) window.open(link, '_self');
    },
    /**
     * Fires when an autocomplete list item is selected
     * @param e {object} event
     */
    confirmAutocomplete(e) {
      const productIdentifiers = e.text.value;
      const displayName = e.text.label;

      trackEventMapFor(displayName, 'Product Selector - Identified - Selected Product');

      this.setProductSearchValue(displayName, productIdentifiers);
    },

    /**
     * Fires when an autocomplete list item is highlighted
     * @param e {object} event
     */
    onAutoCompleteTabSelect(e) {
      this.setProductSearchValue(e.text.label, e.text.value);
    },

    /**
     * Sets the value of the product search fields, if supplied
     * @param searchTerm {string}
     * @param productIdentifiers {object}
     * @returns {searchView}
     */
    setProductSearchValue(searchTerm, productIdentifiers) {
      if (typeof searchTerm !== 'undefined') {
        this.$refs.autocompleteInput.value = searchTerm;
      }

      if (
        typeof productIdentifiers !== 'undefined'
        && typeof productIdentifiers.productId !== 'undefined'
      ) {
        this.confirmedProductIdentifiers = productIdentifiers;
      }
    },
    setProductIdentifiers(product) {
      if (product.partNumber) this.partNumber = product.partNumber;
      if (product.productId) this.productId = product.productId;
    },
    async handleSubmit() {
      let productId = false;
      let partNumber = false;

      const { focus } = this.customProps;
      const urlParams = Utils.getObjectCopy(this.$store.getters.urlParams);

      const searchTerm = this.$refs.autocompleteInput.value.trim();
      this.$store.commit('productSearchTermUpdate', searchTerm);

      trackEventMapFor(this.internalSearchTerm, 'Product Selector - Customer Input');

      let productOverride = this.$store.getters.productSearchOverrideByTerm(searchTerm);
      const fuzzyMatchedProducts = this.$store.getters.productListByTerm(searchTerm);
      const exactMatchedProducts = this.$store.getters.productMatchByTerm(searchTerm);
      let serialNumberSearchFlag = false;
      let intendedProductFlag = false;
      let exactMatchFlag = false;

      if (this.confirmedProductIdentifiers) this.setProductIdentifiers(this.confirmedProductIdentifiers);
      else if (exactMatchedProducts.length === 1) {
        this.setProductIdentifiers(exactMatchedProducts[0]);
        exactMatchFlag = true;
      } else if (productOverride.length > 0) {
        productOverride = productOverride.pop();
        this.setProductIdentifiers({ productId: productOverride.overrideProductId });
        intendedProductFlag = true;
      } else if (fuzzyMatchedProducts.length === 1) {
        trackEventMapFor(fuzzyMatchedProducts[0].displayName, 'Product Selector - Identified - Single Result');
        this.setProductIdentifiers(fuzzyMatchedProducts[0]);
      } else if (
        fuzzyMatchedProducts.length >= ComponentConfig.default.minSearchResults
        && fuzzyMatchedProducts.length <= ComponentConfig.default.maxSearchResults
        && this.$store.getters.productSearchErrorOverrideByTerm(searchTerm).length === 0
      ) {
        trackEventMapFor(this.internalSearchTerm, 'Product Selector - Multiple Match');

        urlParams.productSearch = encodeURIComponent(searchTerm);
        urlParams.tab = focus || urlParams.tab;

        if (this.faqSideDoorEnabled) {
          this.$store.commit('noProductFlowFlagUpdate', false);
        }

        this.$store.dispatch('updateUrlParams', {
          params: urlParams,
          pushHistoryEntryFlag: true,
        });

        this.$store.commit('isQuickLinkClickedFlagUpdate', false);
        this.$store.commit('productFilteredListUpdate', fuzzyMatchedProducts);
      } else if (searchTerm.length > 0) {
        this.setProductIdentifiers({ productId: searchTerm });
        serialNumberSearchFlag = true;
      }

      productId = this.productId;
      partNumber = this.partNumber;

      if (productId) {
        if (focus && focus === this.$store.getters.tabTopicsId) {
          urlParams.contactOverride = true;
          this.$store.commit('urlParamsUpdate', urlParams);
        }

        try {
          await this.fetchProductDetails({
            params: {
              focus: this.customProps.focus,
              partNumber,
              productId,
              serialNumberSearchFlag,
              searchTerm,
              faqSideDoorEnabled: this.faqSideDoorEnabled,
            },
          });

          if (serialNumberSearchFlag && !this.faqSideDoorEnabled && this.getProductDisplayName) {
            trackEventMapFor(this.getProductDisplayName, 'Product Selector - Identified - ID Match');
          }

          if (exactMatchFlag && this.getProductDisplayName) {
            trackEventMapFor(this.getProductDisplayName, 'Product Selector - Identified - Name Match');
          }

          if (intendedProductFlag && this.getProductDisplayName) {
            trackEventMapFor(this.getProductDisplayName, 'Product Selector - Identified - Intended Product Rule');
          }

          if (this.faqSideDoorEnabled) {
            if (this.isProductFaqRelatedContent(this.productDetailsFaqSearch?.faqTags)) {
              if (serialNumberSearchFlag) {
                trackEventMapFor(this.getProductDisplayName, 'Product Selector - Identified - ID Match');
              }
              // eslint-disable-next-line max-len
              trackEventMapFor(`${this.$store.getters.faqDetails.publishedId} - ${this.productDetailsFaqSearch?.displayName}`, 'Product Selector - FAQ Match');
              window.location.href = `
                ${window.location.origin}/${window.AppData.locale}/?identifier=${(partNumber || productId)}&faq=${urlParams.faq}&tab=topics
              `;
              return;
            } throw new Error('Content not compatible');
          } else if (!this.$store.getters.product) {
            throw new Error('Product not found');
          }

          this.$store.commit('selectedTabUpdate', this.$store.getters.urlParams.tab);

          if (focus) {
            const focusUrlParams = Utils.getObjectCopy(this.$store.getters.urlParams);

            // We never want to have both PID and part number in the URL at once
            // This is handled elsewhere appropriately - but here we do a redirect
            // which was bypassing this functionality. This simply ensures that this
            // will be the case in this scenario.
            if (focusUrlParams.productID && focusUrlParams.partNumber) {
              focusUrlParams.productID = false;
            }

            // eslint-disable-next-line max-len
            const focusRedirectUrl = `${window.location.origin}/${window.AppData.locale}/${FormatUrlParameters.formatUrlParametersObject(focusUrlParams)}`;

            window.location = focusRedirectUrl;
          }
        } catch (err) {
          this.updateProductSearchErrors({ mutation: 'error', value: true });
          this.updateProductSearchErrors({ mutation: 'errorSearchTerm', value: searchTerm });

          let customErrorMessage = this.$store.getters.productSearchErrorOverrideByTerm(searchTerm);

          if (
            this.faqSideDoorEnabled
            && this.productDetailsFaqSearch
            && !this.isProductFaqRelatedContent(this.productDetailsFaqSearch?.faqTags)
          ) {
            this.updateFaqSideDoorSearchError(true);
            // eslint-disable-next-line max-len
            trackEventMapFor(`${this.$store.getters.faqDetails.publishedId} - ${this.productDetailsFaqSearch?.displayName}`, 'Product Selector - FAQ Mismatch');
          } else if (customErrorMessage.length) {
            customErrorMessage = customErrorMessage[customErrorMessage.length - 1];
            this.updateProductSearchErrors({ mutation: 'errorOverrideMessage', value: customErrorMessage });
            trackEventMapFor(this.internalSearchTerm, 'Product Selector - No Match - Custom Error');
            this.customErrorFlag = true;
          } else if (fuzzyMatchedProducts.length === 0) {
            this.updateProductSearchErrors({ mutation: 'zeroResultsErrorMessage', value: true });
            trackEventMapFor(this.internalSearchTerm, 'Product Selector - No Match - Zero Results');
            this.zeroResultsFlag = true;
          } else if (fuzzyMatchedProducts.length > ComponentConfig.default.maxSearchResults) {
            this.updateProductSearchErrors({ mutation: 'specificityErrorMessage', value: true });
            trackEventMapFor(this.internalSearchTerm, 'Product Selector - No Match - Specificity');
            this.tooManyResultsFlag = true;
          } else {
            trackEventMapFor(this.internalSearchTerm, 'Product Selector - No Match - Generic Error');
          }
        }
      } else {
        this.$store.commit('productUpdate', false);
      }
    },
    resetErrors() {
      this.resetSearchErrors();
      this.updateFaqSideDoorSearchError(false);
      this.zeroResultsFlag = false;
      this.tooManyResultsFlag = false;
      this.customErrorFlag = false;
    },

    onProductSearchChange(event) {
      this.internalSearchTerm = event.target.value;

      this.resetErrors();
      this.confirmedProductIdentifiers = false;

      if (this.$refs.autocompleteInput.value.length > 0) {
        Utils.addClass(this.$refs.componentWrapper, 'js__product-search-engaged');
      } else {
        Utils.removeClass(this.$refs.componentWrapper, 'js__product-search-engaged');
      }
    },

    searchProducts(userInput) {
      return FuzzySearch.getFuzzyMatches(this.$store.getters.productList, userInput);
    },

    onErrorMessageLinkClick(e, faqId) {
      e.preventDefault();
      window.open(`https://support.garmin.com/${window.AppData.locale}/?searchType=noProduct&faq=${faqId}`, '_blank');
    },

    onLearnMoreClicked(e, analyticsMatcher) {
      trackEventFor(analyticsMatcher);
      window.open(e.target.href, '_blank');
    },

    autocompleteSetup() {
      if (this.productListAutocomplete.length > 0) {
        // eslint-disable-next-line no-undef
        this.autocomplete = new Awesomplete(
          this.$refs.autocompleteInput,
          {
            minChars: ComponentConfig.default.autocompleteMinChars,
            maxItems: this.productListAutocomplete.length,
            list: this.productListAutocomplete,
            listLabel: this.translations.productFlowAriaLabel,

            // Text is the text displayed in the autocomplete dropdown for each product
            // Input is the text typed by the user
            filter(text, input) {
              return FuzzySearch.isFuzzyMatch(text, input);
            },
          },
        );
      }
    },

    toggle() {
      this.isToolTipClicked = !this.isToolTipClicked;
    },

    onNoProductFlowClick() {
      this.$store.dispatch('noProductFlowEnable');
    },
    triggerAnalytics(label, action, category, productName) {
      trackEventMapFor(label, action, category, productName);
    },
  },
  watch: {
    productListAutocomplete() {
      this.autocompleteSetup();
    },
    faqSideDoorSearchError() {
      if (this.faqSideDoorSearchError) {
        setTimeout(() => {
          const faqIdentifiedMissmatchLink = document.getElementById('faq-identified-missmatch-link');
          faqIdentifiedMissmatchLink.addEventListener('click', () => {
            this.triggerAnalytics('Product Page', 'Product Selector - FAQ Mismatch - Link', null, this.productDetailsFaqSearch?.displayName);
          });
        }, 500);
      }
    },
  },
};
